import { createIcon } from '@chakra-ui/react';

export const RoleOutlineIcon = createIcon({
  displayName: 'RoleOutlineIcon',
  path: (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" fill="none">
        <path
          d="M9.33358 9.07976C9.74595 9.07976 10.0802 8.74547 10.0802 8.33309C10.0802 7.92072 9.74595 7.58643 9.33358 7.58643C8.92121 7.58643 8.58691 7.92072 8.58691 8.33309C8.58691 8.74547 8.92121 9.07976 9.33358 9.07976Z"
          fill="#6E6789"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.33318 9.6665C8.84651 9.6665 7.87318 9.9065 7.83984 10.3865C8.17318 10.8598 8.71984 11.1665 9.33318 11.1665C9.94651 11.1665 10.4932 10.8598 10.8265 10.3865C10.7932 9.9065 9.81984 9.6665 9.33318 9.6665Z"
          fill="#6E6789"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 5.39333V2.18L5 0L0 2.18V5.45333C0 8.48 2.13333 11.3133 5 12C5.36667 11.9133 5.72 11.7867 6.06667 11.6333C6.78667 12.66 7.98 13.3333 9.33333 13.3333C11.54 13.3333 13.3333 11.54 13.3333 9.33333C13.3333 7.35333 11.8933 5.71333 10 5.39333ZM5.33333 9.33333C5.33333 9.70667 5.38667 10.0733 5.48667 10.4133C5.32667 10.4867 5.16667 10.56 5 10.6133C2.88667 9.94667 1.33333 7.78667 1.33333 5.45333V3.05333L5 1.45333L8.66667 3.05333V5.39333C6.77333 5.71333 5.33333 7.35333 5.33333 9.33333ZM9.33333 12C7.86 12 6.66667 10.8067 6.66667 9.33333C6.66667 7.86 7.86 6.66667 9.33333 6.66667C10.8067 6.66667 12 7.86 12 9.33333C12 10.8067 10.8067 12 9.33333 12Z"
          fill="#6E6789"
        />
      </svg>
    </>
  ),
});
